import { render, staticRenderFns } from "./PhoneBrand.vue?vue&type=template&id=9e8660ec&scoped=true"
import script from "./PhoneBrand.vue?vue&type=script&lang=js"
export * from "./PhoneBrand.vue?vue&type=script&lang=js"
import style0 from "./PhoneBrand.vue?vue&type=style&index=0&id=9e8660ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8660ec",
  null
  
)

export default component.exports